import React from 'react';
import ReactDOM from 'react-dom';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './index.css';
import App from './App';
import { HashRouter } from 'react-router-dom'
import { Provider } from 'react-redux';
import store from './redux/store';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { PublicClientApplication, InteractionType, Configuration } from '@azure/msal-browser';
import helpers from './components/helpers';



const option1s:Configuration = {

    auth: {
        authority: "https://login.microsoftonline.com/db1e96a8-a3da-442a-930b-235cac24cd5c",
        clientId: "d676168d-55ad-4754-8482-6705986a51ae",
        
    },
    cache: {
        claimsBasedCachingEnabled: true,
        storeAuthStateInCookie:true // in order to avoid network call to refresh a token every time claims are requested
    },
    


};

const msalInstance = new PublicClientApplication(option1s);

msalInstance.initialize().then(() => {
helpers.authenticateUser(msalInstance, "", "");
});

ReactDOM.render(
    <Provider store={store}>
        <MsalProvider instance={msalInstance}>
            <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                <HashRouter>
                    <App />
                </HashRouter>
            </MsalAuthenticationTemplate>
        </MsalProvider>

    </Provider>, document.getElementById('root'));

